<template>
  <!-- Компонент вопрос -->
  <QuizQuestion :question="question" />
  <!-- Компонент вопрос -->

  <div class="quiz-options quiz__single-choice">
    <div
      v-for="(option, optionIndex) in question.options"
      :key="optionIndex"
      class="quiz__option"
      :class="{
          'selected': !showResults && selectedAnswer === optionIndex,
          'correct': showResults && optionIndex === question.correct_option,
          'incorrect': showResults && selectedAnswer === optionIndex && optionIndex !== question.correct_option,
          'disabled': showResults
        }"
      @click="selectOption(optionIndex)"
    >
      <span>{{ option.text || option }}</span>
      <div class="quiz__option-icon">
        <svg class="icon-correct">
          <use xlink:href="/static/img/sprites/sprite.svg#correct"></use>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import QuizQuestion from "@/components/QuizQuestion/QuizQuestion.vue";

export default {
  name: 'SingleChoice',
  components: {
    QuizQuestion
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    selectedAnswer: {
      type: Number,
      default: null
    },
    showResults: {
      type: Boolean,
      default: false
    }
  },
  emits: ['answer-selected'],
  methods: {
    selectOption(optionIndex) {
      if (!this.showResults) {
        this.$emit('answer-selected', this.question.id, optionIndex);
      }
    }
  }
};
</script>

<style lang="scss">
.quiz-options.quiz__single-choice {
  display: flex;
  flex-direction: column;
  gap: 12px;

  & .quiz__option.disabled.selected {
    opacity: 0.4;
  }
}
</style>
